// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/shipping_rate_mappings_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { CountryResponse } from './country_response_pb';
import { file_responses_v1_country_response } from './country_response_pb';
import type { ShippingRateDefinitionType } from '../../settings/v1/shipping_rate_definition_type_pb';
import { file_settings_v1_shipping_rate_definition_type } from '../../settings/v1/shipping_rate_definition_type_pb';
import type { ShippingRateTier } from '../../settings/v1/shipping_rate_tier_pb';
import { file_settings_v1_shipping_rate_tier } from '../../settings/v1/shipping_rate_tier_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/shipping_rate_mappings_response.proto.
 */
export const file_responses_v1_shipping_rate_mappings_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjJyZXNwb25zZXMvdjEvc2hpcHBpbmdfcmF0ZV9tYXBwaW5nc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIr4EChtTaGlwcGluZ1JhdGVNYXBwaW5nUmVzcG9uc2USQwoIbWFwcGluZ3MYASADKAsyMS5yZXNwb25zZXMudjEuU2hpcHBpbmdSYXRlTWFwcGluZ1Jlc3BvbnNlLk1hcHBpbmca2QMKB01hcHBpbmcSLgoHY291bnRyeRgBIAEoCzIdLnJlc3BvbnNlcy52MS5Db3VudHJ5UmVzcG9uc2USVwoOcHJvdmlkZXJfcmF0ZXMYAiADKAsyPy5yZXNwb25zZXMudjEuU2hpcHBpbmdSYXRlTWFwcGluZ1Jlc3BvbnNlLk1hcHBpbmcuUHJvdmlkZXJSYXRlcxrEAgoNUHJvdmlkZXJSYXRlcxJcCg5zaGlwcGluZ19yYXRlcxgBIAMoCzJELnJlc3BvbnNlcy52MS5TaGlwcGluZ1JhdGVNYXBwaW5nUmVzcG9uc2UuTWFwcGluZy5Qcm92aWRlclJhdGVzLlJhdGUSFQoNc2hpcHBpbmdfdHlwZRgCIAEoCRq9AQoEUmF0ZRIKCgJpZBgBIAEoBBIMCgRuYW1lGAIgASgJEjUKBHR5cGUYAyABKA4yJy5zZXR0aW5ncy52MS5TaGlwcGluZ1JhdGVEZWZpbml0aW9uVHlwZRIQCghjdXJyZW5jeRgEIAEoCRIWCglmcmVlX2Zyb20YBSABKAFIAIgBARIsCgVyYXRlcxgGIAMoCzIdLnNldHRpbmdzLnYxLlNoaXBwaW5nUmF0ZVRpZXJCDAoKX2ZyZWVfZnJvbUKMAQoQY29tLnJlc3BvbnNlcy52MUIhU2hpcHBpbmdSYXRlTWFwcGluZ3NSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM',
        [
            file_responses_v1_country_response,
            file_settings_v1_shipping_rate_definition_type,
            file_settings_v1_shipping_rate_tier,
        ]
    );

/**
 * @generated from message responses.v1.ShippingRateMappingResponse
 */
export type ShippingRateMappingResponse = Message<'responses.v1.ShippingRateMappingResponse'> & {
    /**
     * @generated from field: repeated responses.v1.ShippingRateMappingResponse.Mapping mappings = 1;
     */
    mappings: ShippingRateMappingResponse_Mapping[];
};

/**
 * Describes the message responses.v1.ShippingRateMappingResponse.
 * Use `create(ShippingRateMappingResponseSchema)` to create a new message.
 */
export const ShippingRateMappingResponseSchema: GenMessage<ShippingRateMappingResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shipping_rate_mappings_response, 0);

/**
 * @generated from message responses.v1.ShippingRateMappingResponse.Mapping
 */
export type ShippingRateMappingResponse_Mapping = Message<'responses.v1.ShippingRateMappingResponse.Mapping'> & {
    /**
     * @generated from field: responses.v1.CountryResponse country = 1;
     */
    country?: CountryResponse | undefined;

    /**
     * @generated from field: repeated responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates provider_rates = 2;
     */
    providerRates: ShippingRateMappingResponse_Mapping_ProviderRates[];
};

/**
 * Describes the message responses.v1.ShippingRateMappingResponse.Mapping.
 * Use `create(ShippingRateMappingResponse_MappingSchema)` to create a new message.
 */
export const ShippingRateMappingResponse_MappingSchema: GenMessage<ShippingRateMappingResponse_Mapping> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shipping_rate_mappings_response, 0, 0);

/**
 * @generated from message responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates
 */
export type ShippingRateMappingResponse_Mapping_ProviderRates =
    Message<'responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates'> & {
        /**
         * @generated from field: repeated responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates.Rate shipping_rates = 1;
         */
        shippingRates: ShippingRateMappingResponse_Mapping_ProviderRates_Rate[];

        /**
         * @generated from field: string shipping_type = 2;
         */
        shippingType: string;
    };

/**
 * Describes the message responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates.
 * Use `create(ShippingRateMappingResponse_Mapping_ProviderRatesSchema)` to create a new message.
 */
export const ShippingRateMappingResponse_Mapping_ProviderRatesSchema: GenMessage<ShippingRateMappingResponse_Mapping_ProviderRates> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shipping_rate_mappings_response, 0, 0, 0);

/**
 * @generated from message responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates.Rate
 */
export type ShippingRateMappingResponse_Mapping_ProviderRates_Rate =
    Message<'responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates.Rate'> & {
        /**
         * @generated from field: uint64 id = 1;
         */
        id: bigint;

        /**
         * @generated from field: string name = 2;
         */
        name: string;

        /**
         * @generated from field: settings.v1.ShippingRateDefinitionType type = 3;
         */
        type: ShippingRateDefinitionType;

        /**
         * @generated from field: string currency = 4;
         */
        currency: string;

        /**
         * free_from is the cart subtotal the rate becomes free delivery from, in
         * the rate's currency. Optional because a rate with no free shipping
         * threshold has none, which is not the same as a threshold of zero —
         * that one is free from the first order.
         *
         * @generated from field: optional double free_from = 5;
         */
        freeFrom?: number | undefined;

        /**
         * rates are the tiers of the definition: the delivery cost and the
         * transit estimate per bound. A flat definition has a single unbounded
         * tier, an order amount or package weight one has a tier per band.
         *
         * @generated from field: repeated settings.v1.ShippingRateTier rates = 6;
         */
        rates: ShippingRateTier[];
    };

/**
 * Describes the message responses.v1.ShippingRateMappingResponse.Mapping.ProviderRates.Rate.
 * Use `create(ShippingRateMappingResponse_Mapping_ProviderRates_RateSchema)` to create a new message.
 */
export const ShippingRateMappingResponse_Mapping_ProviderRates_RateSchema: GenMessage<ShippingRateMappingResponse_Mapping_ProviderRates_Rate> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shipping_rate_mappings_response, 0, 0, 0, 0);
